import { NavLink } from "react-router-dom"
import useIsMobile from "../hook/useIsMobile"

export default function Footer() {

  const isMobile = useIsMobile();

  const InfoLabel = ({title, content}) => {
    return (
      <div className="flex items-center gap-[8px] text-label1">
        <div className='text-label-100 '>{title}</div>
        
        <hr className="w-[1px] h-[12px] border-none bg-[#525252]"/>

        <div className='text-label-100 '>{content}</div>
      </div>
    )
  }
    
  return (
    <footer className='w-full bg-[#161616] py-[100px]'>
      <div className='wrapper'>
        <div>
          <img
            src='/logo_white.png'
            className='w-[58px] lg:w-[68px] opacity-50'
          />
        </div>

        <hr className='my-[28px] lg:my-[32px] h-[1px] border-0 bg-[#393939]'/>

        <div className='flex justify-between'>
          <div>
            <div className='flex items-center gap-x-[5px] lg:gap-x-[16px] text-label-100 text-label2 lg:text-heading3'>
              <NavLink to='/terms/use'>서비스이용약관</NavLink>
              <hr className='w-[1px] h-[12px] border-none bg-[#525252]'/>
              <NavLink to='/terms/privacy'>개인정보처리방침</NavLink>
              <hr className='w-[1px] h-[12px] border-none bg-[#525252]'/>
              <NavLink to='/terms/ecommerce'>전자상거래표준약관</NavLink>
            </div>

            <div className='w-full lg:w-[430px] flex flex-wrap gap-x-[16px] gap-y-[6px] mt-[28px] lg:mt-[32px]'>
              <InfoLabel title="회사명" content="주식회사 모듈링크"/>
              <InfoLabel title="대표이사" content="박지홍"/>
              <InfoLabel title="사업자등록번호" content="890-87-01460"/>
              <InfoLabel title="통신판매번호" content="2024-경북칠곡-0230"/>
              <InfoLabel title="이메일" content="help@module-link.com"/>
            </div>

            <div className='mt-[46px]'>
              <div className='text-label1 lg:text-body1 text-label-100'>
                © 2025 MODULE LINK All rights reserved.
              </div>

              <a className={!isMobile ? 'hidden' : ''} href='https://www.module-link.com'>
                <img 
                  src='https://www.module-link.com/logo_white.png'
                  className='mt-[30px] w-[122px] aspect-auto opacity-50'
                />
              </a>
            </div>
          </div>

          <a className={isMobile ? 'hidden' : ''} href='https://www.module-link.com'>
            <img 
              src='https://www.module-link.com/logo_white.png'
              className='w-[122px] aspect-auto opacity-50'
            />
          </a>
        </div>
      </div>
    </footer>
  )
}